import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import Fr_SeoInfo from './Fr_SeoInfo'
import En_SeoInfo from './En_SeoInfo'
import Ru_SeoInfo from './Ru_SeoInfo'

import { getLangFromPath } from '../../../i18next'
import cls from './seoIndex.module.sass'

interface Props {
    show: boolean
}

const SeoIndex = ({ show }: Props) => {
    const location = useLocation()
    const [currentLang, setCurrentLang] = useState(getLangFromPath(location.pathname))

    useEffect(() => {
        setCurrentLang(getLangFromPath(location.pathname))
    }, [location.pathname])
    return (
        <div className={show ? cls['show'] : cls['hidden']}>
            {currentLang === 'en' && <En_SeoInfo />}
            {currentLang === 'ru' && <Ru_SeoInfo />}
            {currentLang === 'fr' && <Fr_SeoInfo />}
        </div>
    )
}

export default SeoIndex
